import { useContext } from "react";
import { Auth0Context, Auth0ContextInterface } from "@auth0/auth0-react";

/**
 * This can be removed post migration.
 * @returns
 */
export function useSafeAuth0(): Partial<Auth0ContextInterface> {
  const context = useContext(Auth0Context);

  if (!context) {
    // Return safe defaults when Auth0 provider is not present
    return {
      isAuthenticated: false,
    };
  }

  return context;
}
